import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Divider, ListItemIcon, Typography } from '@mui/material';
import { MdEdit as EditIcon } from 'react-icons/md';
import { MdDeleteOutline as DeleteOutlineIcon } from 'react-icons/md';

interface IActiveMemberMenuProps {
  id: string;
  open: boolean;
  anchorEl: null | HTMLElement;
  handleClose: () => void;
  handleEditRoles: () => void;
  handleRemoveMember: () => void;
  isReadOnlyUser: boolean;
  isSelf: boolean;
}

const ActiveMemberMenu: React.FC<
  React.PropsWithChildren<IActiveMemberMenuProps>
> = ({
  id,
  open,
  anchorEl,
  handleClose,
  handleEditRoles,
  handleRemoveMember,
  isReadOnlyUser,
  isSelf,
}) => {
  return (
    <Menu
      key={id}
      id='active-member-menu'
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}>
      <MenuItem
        disabled={isReadOnlyUser}
        onClick={() => {
          handleClose();
          handleEditRoles();
        }}>
        <ListItemIcon>
          <EditIcon fontSize='small' />
        </ListItemIcon>
        <Typography variant='body2'>Edit Roles</Typography>
      </MenuItem>
      <Divider />
      <MenuItem
        disabled={isReadOnlyUser && !isSelf}
        onClick={() => {
          handleClose();
          handleRemoveMember();
        }}>
        <ListItemIcon>
          <DeleteOutlineIcon fontSize='small' color='error' />
        </ListItemIcon>
        <Typography color='error' variant='body2'>
          Remove Member
        </Typography>
      </MenuItem>
    </Menu>
  );
};

export default ActiveMemberMenu;
